(() => {
  if (customElements.get('pt-fabric-ugc')) return;
  customElements.define('pt-fabric-ugc', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      const source = this.querySelector('script[type="application/json"]');
      const list = this.querySelector('[data-photos]');
      if (!source || !list) return;
      let records;
      try { records = JSON.parse(source.textContent); } catch { return; }
      if (!Array.isArray(records)) return;
      const candidates = [...new Map(records.filter(item => item.id && item.src).map(item => [item.id, item])).values()];
      // Partial Fisher-Yates selects ten unique records across the existing curated pools.
      const count = Math.min(10, candidates.length);
      const fragment = document.createDocumentFragment();
      for (let i = 0; i < count; i++) {
        const next = i + Math.floor(Math.random() * (candidates.length - i));
        [candidates[i], candidates[next]] = [candidates[next], candidates[i]];
        const item = document.createElement('div');
        item.className = 'pt-plp-ugc-rail__item';
        const photo = document.createElement('img');
        photo.className = 'theme-img';
        photo.src = candidates[i].src;
        photo.alt = candidates[i].alt || 'Customer photo';
        photo.width = 240;
        photo.height = 240;
        photo.loading = 'lazy';
        photo.decoding = 'async';
        item.append(photo);
        fragment.append(item);
      }
      list.replaceChildren(fragment);
      source.remove();
      this.dataset.ready = 'true';
      const scroller = this.querySelector('.pt-plp-ugc-rail__scroller');
      this.querySelectorAll('[data-direction]').forEach(button => {
        button.hidden = false;
        button.addEventListener('click', () => scroller.scrollBy({
          left: Number(button.dataset.direction) * scroller.clientWidth * .8,
          behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
        }));
      });
    }
  });
})();
